<template>
    <div>
        <v-dialog v-model="addSerialNumbersDialog" content-class="rounded-lg" max-width="550px" persistent>
            <v-card>
                <v-card-title>
                    {{
                        canAddSerialNumber? $t('InvoiceBuyPage.add-serial-number') : $t('InvoiceBuyPage.serial-numbers')
                    }}
                </v-card-title>
                <v-card-text>
                    <bee-handy-smart-table
                        ref="serialNumberTable"
                        :headers="serialNumberHeaders"
                        :items="canAddSerialNumber ? tableInputs['serial-number'] || [] : serialNumbers"
                        v-model="serialNumber"
                        zebra
                        pagination-on-scroll
                        hide-inputs-details
                        hide-no-data-area
                        with-columns-divider
                        stay-in-input-fields
                        shown-rows-text=""
                        :show-add-row="canAddSerialNumber"
                        divided-column
                    >
                        <!-- @keydown.enter="
                            resetSerialNumberValue();
                        
                        "               -->
                        <template v-slot:input.value="{attr}">
                            <v-combobox
                                v-model="serialNumber.value"
                                v-bind="attr"
                                autofocus
                                :items="materialSerialNumbers.filter(v => !tableInputs['serial-number']?.find(c => c.value === v))"
                                class="text-subtitle-2"
                                dense
                                hide-details
                                @change="checkMaterialSerialNumber(tableInputs.materialId, serialNumber.value)"     
                                @keydown.enter="resetSerialNumberValue"              
                            >
                                <template v-slot:item="{ item, on, attrs }" >
                                    <v-list-item v-on="on" v-bind="attrs" class="text-subtitle-2" dense @click="resetSerialNumberValue">
                                        {{ item }}
                                    </v-list-item>
                                </template>
                                <template v-slot:selection="{item}">
                                    {{ item }}
                                </template>
                            </v-combobox>
                        </template>
                        <template v-slot:item.actions="{index}">
                            <v-btn v-if="canAddSerialNumber" small icon  class="ms-2 pa-0" color="red" @click="tableInputs['serial-number'].splice(index, 1)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </bee-handy-smart-table>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-btn
                        text
                        color="red"
                        @click="canAddSerialNumber = false;addSerialNumbersDialog = false"
                    >
                        {{ $t('buttons.cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="serialNumberAlertDialog" content-class="rounded-lg" max-width="550">
            <v-card>
                <v-card-title>
                    {{ $t('InvoiceBuyPage.choose-serial-number-alert') }}
                </v-card-title>
                <v-card-text class="pb-2 pt-2">
                    {{ $t('headers.serial-number') }}
                    :
                    {{ serialNumberAlertText }}
                    <br>
                    {{ $t('InvoiceBuyPage.choose-serial-number-alert-content') }}
                </v-card-text>
                <v-card-actions class="pt-1">
                    <v-btn
                        @click="serialNumberAlertDialog = false"
                        color="transparent"
                        class="green--text"
                        text
                    >
                        {{ $t('buttons.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="white" style="width: 100%;" id="tool-bar">
        <v-row class="ma-0 pa-3" align="center">
            <v-col class="pt-0 " cols="12">
                <v-row>
                    <v-col cols="auto">
                        <slot name="breadcrumbs" :item="true"></slot>
                    </v-col>
                    <v-col sm="auto" cols="auto" class="d-flex flex-row justify-start py-1">
                        <bee-bond-up-down
                            v-model="journalNo"
                            @keydown-enter-prevent="fetchJournalByNo()"
                            @programmatically-changed="fetchJournalByNo()"
                            :items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? materials_journals.map(c => c.sub_journal_no) : materials_journals.map(c=>c.no)"
                            :disabled="loading || !materials_journals.length"
                            class="medium-placeholder"
                            :label="$t('MaterialsJournalPage.journal-number-automatic-or-manual')"
                        ></bee-bond-up-down>
                    </v-col>
                    <!-- add button -->
                    <v-col sm="auto" cols="12" class="d-flex flex-column px-lg-0 justify-center py-1">
                        <bee-btn  
                            @click="addEntryDialog = true"
                            :content="$t('MaterialsJournalPage.add')"
                            color="addingColor"
                            context="materials_journal"
                            icon="fa-plus"
                            :action-name="actions.CREATE"
                            :disabled="file_is_locked || loading"
                        ></bee-btn>
                    </v-col>
                    <v-col
                    	v-if="!journal.invoice_id && !journal.manufacturing_file_id && !journal.transaction_bond_id && !journal.is_posted"
                    	cols="12"
                    	sm="auto"
                    	xs="auto"
                    	md="auto"
                    	lg="auto"
                    	class="d-flex flex-column justify-center"
                    >
                        <bee-btn
                            @click="deleteJournalDialog = true"
                            :content="$t('MaterialsJournalPage.delete')"
                            color="deletingColor"
                            context="materials_journal"
                            icon="fa-trash"
                            :action-name="actions.DELETE"
                            :disabled="file_is_locked || loading"
                        ></bee-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="d-flex align-center">
                        <v-tooltip right>
                            <template v-slot:activator="{on, attrs}">
                                <div
                                    v-on="on"
                                    v-bind="attrs"
                                >
                                    <v-btn
                                        icon
                                        :loading="materialsLoading"
                                        @click="fetchMaterials()"
                                    >
                                        <v-icon  color="primary" size="18">
                                           fa-sync
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </template>
                            {{$t('update-materials')}}
                        </v-tooltip>
                    </v-col>
                    <v-col cols="auto" class="d-flex justify-lg-end py-1">
                        <router-link style="text-decoration: none;" :to="{name: 'all-materials-journals', query: {status: 2}}">
                            <bee-progress-circular
                                :size="60"
                                :width="6"
                                :title="material_journals_posting_ratio_caption"
                                :value="material_journals_posting_ratio"
                                :tooltip="material_journals_posting_ratio_tooltip"
                            ></bee-progress-circular>
                        </router-link>
                    </v-col>
                </v-row>
            </v-col>
            <v-col lg="12" md="12" class="flex-grow-1">
                <v-row class="border">
                    <!-- section -->
                    <v-col cols="auto" class="d-flex align-center">
                        <bee-date-picker
                            v-model="materialsJournalData.date"
                            ref="dateEdit"
                            :disabled="true"
                            context="invoice"
                            :action-name="actions.EDIT"
                            :label="$t('inputs.bond-date')"
                            :rules="[
                                rules.date,
                                v => new Date(v) <= new Date() || false
                            ]"
                            :hide-details="true"
                        ></bee-date-picker>
                    </v-col>
                    <!-- warehouse -->
                    <v-col md="3" sm="auto" cols="12" class="d-flex flex-column justify-center">
                        <bee-autocomplete 
                            v-model="materialsJournalData.warehouseId" 
                            :disabled="journal.warehouse_id? true: journal.is_posted || file_is_locked" 
                            context="materials_journal"
                            :items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? warehousesForKeeper : warehouses"
                            :item-text="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_name' : 'name'"
                            :item-value="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id'"
                            :label="$t('MaterialsJournalPage.warehouse')"
                            @change="changeWarehouse()"
                            :hide-details="true"
                            :action-name="actions.GET"
                        ></bee-autocomplete>
                    </v-col>
                    <v-col v-if="useMaterialsJournalType" cols="12" sm="4" md="3" lg="2">
                        <v-select
                            v-model="materialsJournalData.type"
                            dense
                            outlined
                            hide-details
                            :disabled="journal.is_posted || file_is_locked"
                            label="النوع"
                            item-text="name"
                            item-value="value"
                            @change="updateJournal()"
                            :items="materialsJournalsTypes"
                        >
                        </v-select>
                    </v-col>
                    <!-- caption -->
                    <v-col cols="12" sm="4" md="3" lg="2">
                        <v-text-field 
                        v-model="materialsJournalData.notes"
                        :disabled="journal.is_posted || file_is_locked"
                        :label="$t('inputs.notes')"
                        outlined
                        dense
                        hide-details
                        @change="updateJournal()"
                        />
                    </v-col>
                    <v-spacer/>

                    <!-- section -->
                    <v-col lg="auto" sm='auto' cols="12" class="d-flex justify-center flex-column ps-lg-0 py-lg-0">
                        <bee-btn
                            v-if="
                                !journal.transaction_bond_id && (
                                    useUnPostingPermission
                                        ? (!journal.is_posted || (journal.is_posted && canUnPost))
                                        : true
                                )
                            "
                            context="materials_journal"
                            :action-name="actions.EDIT"
                            :content="$vuetify.breakpoint.lgAndUp 
                                ? journal.is_posted
                                    ? journal.invoice_id 
                                        ? $t('MaterialsJournalPage.view-invoice')
                                        : journal.manufacturing_file_id ? $t('MaterialsJournalPage.view-manufacturing-bond') : $t('MaterialsJournalPage.edit')
                                    : $t('MaterialsJournalPage.save')
                                : ''
                            " 
                            :icon="journal.is_posted ? (journal.invoice_id || journal.manufacturing_file_id ? 'far fa-share-square fa-rotate-180' : 'fa-envelope-open') : 'fa-envelope'" 
                            :outer-class="$vuetify.breakpoint.lgAndUp ? 'py-8': ''"
                            :disabled="(file_is_locked && !journal.invoice_id && !journal.manufacturing_file_id) || loading"
                            :color="journal.is_posted ? 'deletingColor' : 'blueGray'"
                            @click="journal.is_posted ? ( journal.invoice_id ? reForwardToRelatedInvoice() : journal.manufacturing_file_id ? reForwardToRelatedManufacturingFile() : unPost()) : post()">
                        >
                        </bee-btn>
                    </v-col>
                    <v-col md="1" sm="12" 
                        :class="[
                            journal.is_posted ? 'postedColor': 'unpostedColor',
                            $vuetify.breakpoint.mdAndUp ? 'border-round-end': 'border-round-bottom'
                        ]"
                        class="d-flex justify-center align-center white--text text--title text-center text-wrap"
                    >
                        <span class="text-center align-center" style="line-height: 1.2;">
                            {{journal.is_posted ? '' : $t('MaterialsJournalPage.not')}}
                            <br v-if="!journal.is_posted && $vuetify.breakpoint.mdAndUp">
                            {{$t('MaterialsJournalPage.posted')}}
                        </span>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        </div>
        <!-- table -->
        <div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
        <v-card flat>
            <v-card-text class="pt-0 px-3">
                <!-- <bee-smart-table
                    v-if="false"
                    v-model="tableInputs"
                    max-height="65vh"
                    mode="materials-journals"
                    context="materials_journal"
                    :action-name="actions.CREATE"
                    ref="table" 
                    :with-color="false"
                    :zebra="true"
                    empty-state="dashes"
                    :hide-footer="true"
                    :addable="!journal.is_posted"
                    :editable="!journal.is_posted" 
                    :configs="configs"
                    :headers="headers0"
                    :items="items || []"
                    :show-menu-actions="true"
                    highlighted-color="blueGrayLighten3"
                    :highlighted-expression="(item)=>{ return item.id == parseInt($route.query.entryId) }" 
                    @cell-change="items[$event.index][$event.header.value] = $event.value"
                    @reset-data="fetchEntry($event)"
                    @row-edited="updateEntry($event)"
                    @row-added="addEntry($event)"
                    @delete-item="deleteEntry($event)"
                    @material-statement="forwardToMaterialStatement($event)"
                    :right-click-menu-items="actionsList"
                    :messagesSelectRowValidation="messagesSelectRowValidation"
                    @nblur="handlBlurJournalTable"
                ></bee-smart-table> -->

                <bee-handy-smart-table
                    v-if="true"
                    v-model="tableInputs"
                    ref="table"
                    :headers="headers"
                    :items="items || []"
                    zebra
                    dense
                    with-columns-divider
                    pagination-on-scroll
                    shown-rows-text=""
                    fixed-header
                    :validation-messages.sync="ValidationMessages"
                    :loading="loading || entryLoading"
                    :height="$vuetify.breakpoint.height - 255"
                    hide-no-data-area
                    hide-inputs-details
                    stay-in-input-fields
                    :show-add-row="Boolean(!journal.is_posted && $route.params.id)"
                    :context-menu-items="contextMenuItems"
                    :editable-rows="!journal.is_posted"
                    @context-menu-materialStatement="forwardToMaterialStatement($event.item)"
                    @context-menu-edit="({ item }) => entryId = item.id"
                    @context-menu-delete="deleteEntry($event.item)"
                    @keydown.enter="entryHandler"
                    @dblclick:row="(e, { item }) => forwardToMaterialStatement(item)"
                    @change-inQuantity="materialSerialNumbers = []"
                    @change-materialId="getMaterialPrice"
                >
                    
                    <template v-slot:input.warehouseId="{ attr, on }">
                        <v-autocomplete
                            v-on="on"
                            v-bind="attr"
                            class="text-subtitle-2"
                            :items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? warehousesForKeeper : warehouses"
                            :item-text="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_name' : 'name'"
                            :item-value="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id'"
                        >
                        </v-autocomplete>
                    </template>

                    <template v-slot:input.materialId="{ attr, on }">
                        <v-autocomplete
                            v-on="on"
                            v-bind="attr"
                            class="text-subtitle-2"
                            :items="warehouseMaterials"
                            item-text="name"
                            item-value="id"
                        >
                            <template v-slot:item="data">
                                <v-list-item
                                    v-on="data.on"
                                    v-bind="data.attrs"
                                    dense
                                >
                                    <div class="d-flex flex-column py-1">
                                        <span class="pe-3">
                                            {{ data.item.no + '-'+ data.item.name }}
                                        </span>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <bee-material-amount-label :with-color="true" :value="data.item?.balance" :show-zeros-values="true"></bee-material-amount-label>

                                </v-list-item>
                            </template>
                        </v-autocomplete>
                    </template>
                    <template v-slot:item.serial-number="{item}">
                        <div class="d-flex align-center justify-center">
                            <v-btn v-if="item.serial_number?.length" text :ripple="false" class="" @click.stop="serialNumbers = item.serial_number ;addSerialNumbersDialog = true">
                                <span class=" greyDarken2--text me-1">
                                    {{ 
                                        item.serial_number?.length || null
                                    }}
                                </span>
                                <v-icon small>
                                    mdi-script-text-outline
                                </v-icon>
                            </v-btn>
                            <span v-else>-</span>
                        </div>
                    </template>
                    <template v-slot:input.serial-number="{on, attr}">
                        <v-combobox
                            v-model="serialNumber.value"
                            v-bind="attr"
                            :items="materialSerialNumbers.filter(v => !tableInputs['serial-number']?.find(c => c.value === v))"
                            class="text-subtitle-2"
                            dense
                            hide-details
                            @change="checkMaterialSerialNumber(tableInputs.materialId, serialNumber.value)"     
                            @keydown.enter="resetSerialNumberValue"              
                        >
                            <template v-slot:append>
                                <span class="mt-2 me-1 greyDarken2--text">
                                    {{ 
                                    tableInputs['serial-number']?.length || null
                                    }}
                                </span>
                                <v-icon small  class="mt-2" @click.stop.prevent="$refs['input-serial-number'].isMenuActive = false;canAddSerialNumber = true;addSerialNumbersDialog = true;">
                                    mdi-script-text-outline
                                </v-icon>
                            </template>
                            <template v-slot:item="{ item, on, attrs }" >
                                <v-list-item v-on="on" v-bind="attrs" class="text-subtitle-2" dense @click="resetSerialNumberValue">
                                    {{ item }}
                                </v-list-item>
                            </template>
                            <template v-slot:selection="{item}">
                                {{ item }}
                            </template>
                        </v-combobox>
                    </template>
                    <template v-slot:input.accountId="{ attr, on }">
                        <v-autocomplete
                            v-on="on"
                            v-bind="attr"
                            class="text-subtitle-2"
                            :items="configs.accounts"
                            item-text="name"
                            item-value="id"
                        ></v-autocomplete>
                    </template>

                    <template v-slot:input.date="{ attr, on }">
                        <v-text-field
                            v-on="on"
                            v-bind="attr"
                            class="text-subtitle-2"
                            type="date"
                        ></v-text-field>
                    </template>
                    <template v-slot:no-input.hint>
                        <v-menu bottom v-if="ValidationMessages.length > 0">
                            <template v-slot:activator="{ on, attr }">
                                <v-icon
                                    v-on="on"
                                    v-bind="attr"
                                    color="danger-color"
                                    size="20"
                                >mdi-information</v-icon>
                            </template>

                            <v-list>
                                <v-list-item
                                    v-for="(message, i) in inputsValidationMessages"
                                    :key="i"
                                    dense
                                    class="px-2"
                                >
                                    <v-list-item-icon class="me-0 mb-0">
                                        <v-icon color="danger-color" x-small>mdi-circle-half</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title class="danger-color--text">
                                        {{message}}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>

                    <template v-slot:item.hint="{ item, index }">
                        <div class="text-center">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attr }">
                                    <v-btn
                                        small
                                        icon
                                        v-bind="attr"
                                        v-on="on"
                                        width="32"
                                    >
                                        <v-icon>
                                            mdi-dots-vertical
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item @click="forwardToMaterialStatement(item)">
                                        <v-list-item-content class="pa-0">
                                            {{ $t('MaterialsJournalPage.context-menu.material-statement') }}
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item 
                                        :disabled="journal.is_posted" 
                                        @click="$refs.table.activeEditForRow(index); entryId = item.id"
                                    >
                                        <v-list-item-content class="pa-0">
                                            {{ $t('MaterialsJournalPage.context-menu.edit') }}
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item 
                                        :disabled="journal.is_posted" 
                                        @click="deleteEntry(item)"
                                    >
                                        <v-list-item-content class="pa-0">
                                            {{ $t('MaterialsJournalPage.context-menu.delete-item') }}
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                </bee-handy-smart-table>
            </v-card-text>
        </v-card>
        <!-- Add dialog -->
        <v-dialog v-model="addEntryDialog" max-width="500" transition="dialog-top-transition">
            <v-card>
                <v-card-title class="headline">{{$t('MaterialsJournalPage.add-journal')}}</v-card-title>
                <v-card-text>
                    <bee-date-picker
                      context="materials_journal"
                      :action-name="actions.CREATE"
                      :label="$t('MaterialsJournalPage.journal-date')"
                      v-model="date"
                      :rules="[rules.date]"
                    ></bee-date-picker>

                    <v-autocomplete 
                        v-if="multipleWarehouses"
                        v-model="warehouseId"
                        :items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? warehousesForKeeper : warehouses"
                        item-text="name"
                        :item-value="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id'"
                        outlined
                        dense
                        :label="$t('inputs.warehouse')"
                    />
                    <v-select
                        v-if="useMaterialsJournalType"
                        v-model="materialsJournalType"
                        dense
                        outlined
                        hide-details
                        label="النوع"
                        item-text="name"
                        item-value="value"
                        :items="materialsJournalsTypes"
                    >
                    </v-select>
                </v-card-text>
                <v-card-actions class="ms-3">
                    <v-btn color="greenDarken1" text @click="addMaterialJournal" :loading="loading" >
                        {{$t('MaterialsJournalPage.create')}}
                    </v-btn>
                    <v-btn color="redDarken1" text @click="addEntryDialog = false" >
                        {{$t('MaterialsJournalPage.cancel')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- delete dialog -->
        <bee-dialog
            @handler="confirmDeleteEntry(); $emit('close')"
            @close="deleteEntryDialog = false"
            v-model="deleteEntryDialog"
            :title="$t('MaterialsJournalPage.delete-entry')"
            :message="$t('MaterialsJournalPage.are-you-sure-you-want-to-delete-the-entry')"
        ></bee-dialog>
        <bee-dialog
            @handler="deleteJournal()"
            @close="deleteJournalDialog = false"
            v-model="deleteJournalDialog"
            :title="$t('MaterialsJournalPage.delete-journal')"
            :message="$t('MaterialsJournalPage.are-you-sure-you-want-to-delete-the-journal')"
        ></bee-dialog>
        </div>
    </div>
</template>

<script>
import rules from "../../../validation";
import actions from "../../../permissions/actions-names.js";
import store from "../../../store/index.js";
import moment from 'moment'
import EventBus from '../../../event-bus';
import { entryDetectedValidation } from './helper/validation-detected-material-entry';
import { mapState, mapGetters } from 'vuex';
// import { refactorMaterialEntry } from "./helper/operations-calculated-properties.js";
import { userType, invoiceType,
 materialsJournalsTypes } from '@/helpers/enums'
import { multipleWarehouses, isMangeUnitAndRegionAndPatchAndLot, useUnPostingPermission, useZeroPriceInMaterialJournals, useMaterialsJournalType } from '@/configs/global'

// FIXME must use config for warehouse allowed warehouse
// const multipleWarehouses = false;
export default {
    data: () => ({
        // FIXME must use config for warehouse allowed warehouse
        multipleWarehouses,
        ...rules,
        actions,
        loading: true,
        default_warehouse_id: null,
        journalNo: null,
        selected_warehouse_id: null,
        deleteEntryDialog: false,
        addEntryDialog: false,
        deleteJournalDialog: false,
        date: new Date().toISOString().substr(0, 10),
        default_journal: {
            is_posted: false
        },
        selected_entry: null,
        messagesSelectRowValidation: [],
        linkedJournalRules:{ in_quantity: true, out_quantity: true, count: true, material_id: true, price: true },
        userType,
        materialsJournalsTypes,
        useMaterialsJournalType,
        tableInputs: {},
        warehouseId: null,
        materialsJournalType: 0,
        isMangeUnitAndRegionAndPatchAndLot,
        useUnPostingPermission,
        invoiceType,
        entryLoading: true,
        ValidationMessages: [],
        notes: null,
        materialsJournalData: {
            date: null,
            warehouseId: null,
            notes: null,
            type: null
        },
        materialsLoading: false,
        materialSerialNumbers: [],
        serialNumbers: [],
        addSerialNumbersDialog: false,
        serialNumber: {},
        canAddSerialNumber: false,
        serialNumberAlertDialog: false,
        serialNumberAlertText: null
    }),
    watch: {
        '$route'(val, oldVal) {
            if(val.params.id) {
                this.fetchJournal(val.params.id);
            } else if(oldVal.params.id && this.materials_journals.find(v => v.id === oldVal.params.id)){
                this.$router.push({ name: 'materials-journal', params: {id: oldVal.params.id}});
            }
        }
    },
    computed:{
        ...mapState({
            ...mapState("materials", ["materials"]),
            ...mapState("configs", ["configs"]),
            ...mapState("materialsJournals", ["materials_journals"]),
            ...mapState("materialsJournals", ["materials_journal"]),
            ...mapState("warehouses", ["warehouses"]),
            userTypePermission: state => state.permissions.user_type,
            // warehousesForKeeper: state => state.warehouses.warehousesForKeeper,
            warehousesForKeeper: state => state.permissions.warehousesForKeeper,
            currentFinancialFiles: state => state.financialFiles.current_financial_file,
            canUnPost: state => state.permissions.selfPermissions.canUnPost,
            currentFinancialFile: state => state.financialFiles.current_financial_file,
            configs: state => state.configs.configs,
            numOfNotPostedMaterialsJournals: state => state.configs.configs.num_of_not_posted_material_journal,
            numOfTotalMaterialsJournals: state => state.configs.configs.num_of_total_material_journal
        }),

        ...mapGetters({
            getWarehouseById: 'warehouses/getById',
            getAccountById: 'configs/getAccountById',
            getMaterialById: 'materials/getMaterialById',
            getSettingByKey: 'settings/getSettingByKey'
        }),
        inputsValidations() {
			const inputs = this.tableInputs;
			return {
				in_quantity: (inputs.inQuantity || inputs.outQuantity) && !(inputs.outQuantity && inputs.inQuantity),
				out_quantity: (inputs.outQuantity || inputs.inQuantity) && !(inputs.outQuantity && inputs.inQuantity),
                material_id: inputs.materialId,
                amount: inputs.amount || useZeroPriceInMaterialJournals
            }
		},
        inputsValidationMessages() {
			const messages = [];
            const input = this.tableInputs
            if (input.inQuantity && input.outQuantity) {
				messages.push(this.$t('table-messages.quantity-on-and-out-forbidden'));
			}
			else if (this.ValidationMessages.includes('invalid-input-inQuantity') || this.ValidationMessages.includes('invalid-input-outQuantity')) {
				messages.push(this.$t('table-messages.quantity-on-or-out-required'))
			}
	
            if (this.ValidationMessages.includes('invalid-input-materialId')) {
                messages.push(this.$t('table-messages.material-required'));
            }
            if (this.ValidationMessages.includes('invalid-input-amount')) {
                messages.push(this.$t('table-messages.price-required'));
            }
			return messages
		},
        journal(){
            return Object.keys(this.materials_journal).length === 0 ? this.default_journal : this.materials_journal  
        },
        items(){
            return this.materials_journal?.entries?.map(obj=> ( {
                    ...obj, 
                    in_quantity: obj.type == 1 ? obj.quantity.quantity : null,
                    out_quantity: obj.type == 2 ? obj.quantity.quantity : null,
                    warehouse_id: this.materials.find(c=>c.id == obj.material_id).warehouse_id,
                    serial_number: obj.serial_number.map((v,i) => ({value: v, id: i + 1}))
                })) 
        },
        warehouseMaterials(){
            return this.materials
            .filter(c => this.tableInputs.warehouseId? c.warehouse_id === this.tableInputs.warehouseId: true)
            .filter(c => c.type == 2)
        },
        file_is_locked(){
            return this.configs?.financial_file?.is_locked 
        },
        on_mdAndUp(){
            return this.$vuetify.breakpoint.mdAndUp
        },
        headers0(){
            const headers = [
                {
                    text: this.$t('MaterialsJournalPage.headers.no'),
                    value: 'no',
                    type: 'string',
                    width: '5%',
                    required: true,
                    editable: false 
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.in-quantity'),
                    value: 'in_quantity',
                    type: 'numeric',
                    width: '10%',
                    required: true,
                    editable: true, rules: [this.linkedJournalRules.in_quantity] 
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.out-quantity'),
                    value: 'out_quantity',
                    type: 'numeric',
                    width: '10%',
                    required: true,
                    editable: true, rules: [this.linkedJournalRules.out_quantity] 
                },
              
                {
                    text: this.$t('MaterialsJournalPage.headers.material'),
                    value: 'material_id',
                    type: 'materials-autocomplete',
                    width: '10%',
                    required: true,
                    editable: true, rules:[this.linkedJournalRules.material_id],
                    // this.materials.filter(c => c.warehouse_id === this.tableInputs.warehouse_id && c.type === 2) : this.materials.filter(c => c.type === 2)
                    settings: { 
                        items: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? this.materials.filter(c => c.warehouse_id === this.default_warehouse_id && c.type === 2) : this.materials.filter(c => c.type === 2), 
                        subItems: this.warehouseMaterials, context: 'materials', actionName: this.actions.GET }
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.count'),
                    value: 'count',
                    type: 'numeric',
                    width: '5%',
                    editable: true
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.price'),
                    value: 'price',
                    type: 'money',
                    width: '10%',
                    required: true,
                    editable: true, rules: [this.rules.money && this.linkedJournalRules.price]
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.notes'),
                    value: 'notes',
                    type: 'string',
                    width: '10%',
                    required: true,
                    editable: true
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.document'),
                    value: 'doc_no',
                    type: 'string',
                    width: '5%',
                    required: true,
                    editable: true
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.account'),
                    value: 'account_id',
                    type: 'accounts-autocomplete',
                    width: '15%',
                    required: true,
                    editable: true, settings: { itemText: 'name' }
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.date'),
                    value: 'date',
                    type: 'date',
                    width: '10%',
                    required: true,
                    editable: true
                },
                { text: '', value: 'hint', type: 'hint', width: '2%', editable: false,},
            ]
            if(isMangeUnitAndRegionAndPatchAndLot) {
                headers.splice(10,0, 
                {
                    text: 'رقم الباتش',
                    name: 'patchNumber',
                    value: 'patchNumber',
                    type: 'string',
                    editable: true,
                    settings: { context: 'invoice', actionName: actions.GET },
                    width: '10%'
                },
                {
                    text: 'رقم اللوت',
                    name: 'lotNumber',
                    value: 'lotNumber',
                    type: 'string',
                    editable: true,
                    settings: { context: 'invoice', actionName: actions.GET },
                    width: '10%'
                },
                {
                    text: 'تاريخ الانتهاء',
                    name: 'endDate',
                    value: 'endDate',
                    type: 'date',
                    editable: true,
                    settings: { context: 'invoice', actionName: actions.GET },
                    width: '13%'
                })
            }
            if((multipleWarehouses && this.userTypePermission !== userType.warehouseKeeper) || (!multipleWarehouses)) {
                headers.splice(3, 0,
                    {
                        text: this.$t('MaterialsJournalPage.headers.warehouse'),
                        value: 'warehouse_id',
                        type: 'autocomplete',
                        width: '10%',
                        required: true,
                        editable: true ,
                        settings: { itemText: 'name', items: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? this.warehousesForKeeper : this.warehouses, clearable: true, itemValue: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id', context: 'warehouses', actionName: actions.GET }
                    },
                )
            }
            return headers
        },
        headers(){
            let headers = [
                {
                    text: this.$t('MaterialsJournalPage.headers.no'),
                    value: 'no',
                    name: 'no',
                    type: 'string',
                    width: '5%',
                    sortable: false,
                    noInput: true
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.in-quantity'),
                    value: 'in_quantity',
                    name: 'inQuantity',
                    type: 'number-format',
                    columnClass: 'px-1',
                    width: 80,
                    inputRules: (() => {
						if (this.inputsValidations.in_quantity) return [];
						else return [() => false];
					})(),
                    sortable: false
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.out-quantity'),
                    value: 'out_quantity',
                    name: 'outQuantity',
                    type: 'number-format',
                    columnClass: 'px-1',
                    width: 80, 
                    inputRules: (() => {
						if (this.inputsValidations.out_quantity) return [];
						else return [() => false];
					})(),
                    sortable: false
                },
              
                {
                    text: this.$t('MaterialsJournalPage.headers.material'),
                    value: 'material_id',
                    name: 'materialId',
                    setValueExpr: value => this.getMaterialById(value)?.name,
                    width: '15%',
                    sortable: false,
                    inputRules: (() => {
						if (this.inputsValidations.material_id) return [];
						else return [() => false];
					})(),
                },
                this.useMaterialSerialNumber 
                    ? {
                        text: this.$t('headers.serial-number'),
                        name: 'serial-number',
                        value: 'serial_number',
                        // disableInput: this.tableDisabledInputs('serial-number'),
                        inputRules:  [() => this.serialNumberValidation],
                        sortable: false,
                        width: 110,
                        type: 'array'
                    } 
                    : null,
                {
                    text: this.$t('MaterialsJournalPage.headers.count'),
                    value: 'count',
                    name: 'count',
                    type: 'number',
                    width: '5%',
                    sortable: false,
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.price'),
                    value: 'price.amount',
                    name: 'amount',
                    type: 'number-format',
                    width: '6%',
                    sortable: false,
                    inputRules: (() => {
						if (this.inputsValidations.amount) return [];
						else return [() => false];
					})(),
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.notes'),
                    value: 'notes',
                    name: 'notes',
                    width: '10%',
                    sortable: false
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.document'),
                    value: 'doc_no',
                    name: 'docNo',
                    type: 'string',
                    width: '5%',
                    sortable: false
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.account'),
                    value: 'account_id',
                    name: 'accountId',
                    setValueExpr: value => this.getAccountById(value)?.name,
                    width: '15%',
                    sortable: false
                },
                {
                    text: this.$t('MaterialsJournalPage.headers.date'),
                    value: 'date',
                    name: 'date',
                    width: 120,
                    sortable: false
                },
                {
					text: '',
					name: 'hint',
					value: 'hint',
					width: 30,
					noNotAvailableText: true,
					divider: false,
					noInput: true, 
                    class: 'px-0',
                    cellClass: 'px-0',
                    sortable: false
				}
            ]
            if(isMangeUnitAndRegionAndPatchAndLot) {
                headers.splice(10,0, 
                {
                    text: 'رقم الباتش',
                    name: 'patchNumber',
                    value: 'patchNumber',
                    type: 'string',
                    editable: true,
                    settings: { context: 'invoice', actionName: actions.GET },
                    width: '10%'
                },
                {
                    text: 'رقم اللوت',
                    name: 'lotNumber',
                    value: 'lotNumber',
                    type: 'string',
                    editable: true,
                    settings: { context: 'invoice', actionName: actions.GET },
                    width: '10%'
                },
                {
                    text: 'تاريخ الانتهاء',
                    name: 'endDate',
                    value: 'endDate',
                    type: 'date',
                    editable: true,
                    settings: { context: 'invoice', actionName: actions.GET },
                    width: 100
                })
            }
            if((multipleWarehouses && this.userTypePermission !== userType.warehouseKeeper) || (!multipleWarehouses)) {
                headers.splice(3, 0,
                    {
                        text: this.$t('MaterialsJournalPage.headers.warehouse'),
                        value: 'warehouse_id',
                        name: 'warehouseId',
                        disableInput: Boolean(this.journal?.warehouse_id) ,
                        setValueExpr: value => this.getWarehouseById(value)?.name,
                        width: '15%',
                        sortable: false
                    },
                )
            }
            headers = headers.filter(Boolean);
            headers.forEach(v => {
                v.columnClass = (v.columnClass || '') + ' text-subtitle-2 px-1' ;
                v.align = 'center';
            })
            return headers
        },
        serialNumberHeaders() {
            return [
                {
                    name: 'id',
                    setValueExpr: (v, i) => i+1 ,
                    value: 'id',
                    width: 30,
                    disableInput: true,
                    sortable: false
                },
                {
                    name: 'value',
                    value: 'value',
                    type: 'string',
                    text: this.$t('InvoiceBuyPage.serial-numbers'),
                    sortable: false
                },
                {
                    name: 'actions',
                    text: '',
                    value: '',
                    noInput: true,
                    width: 30,
                    sortable: false,
                    divider: false
                }
            ]
        },
        // delete this one after you finish... it's old
        actionsList(){
            return [
                {
                    name: 'material-statement',
                    disabled: false,
                    action_name: actions.GET,
                    text: this.$t('MaterialsJournalPage.context-menu.material-statement')
                },
                {
                    name: 'edit',
                    disabled: this.journal.invoice_id || this.journal.manufacturing_file_id || this.journal.is_posted,
                    action_name: actions.EDIT,
                    text: this.$t('MaterialsJournalPage.context-menu.edit')
                }, 
                {
                    name: 'delete-item',
                    disabled: this.journal.invoice_id || this.journal.manufacturing_file_id || this.journal.is_posted,
                    action_name: actions.DELETE,
                    text: this.$t('MaterialsJournalPage.context-menu.delete-item')
                },
            ]
        },

        contextMenuItems() {
            return [
                {
                    event: 'materialStatement',
                    title: this.$t('MaterialsJournalPage.context-menu.material-statement')
                }, 
                {
                    event: 'edit',
                    title: this.$t('MaterialsJournalPage.context-menu.edit'),
                    disabled: Boolean(this.journal.is_posted)
                },
                {
                    event: 'delete',
                    title: this.$t('MaterialsJournalPage.context-menu.delete-item'),
                    disabled: Boolean(this.journal.is_posted)
                }
            ]
        },
        material_journals_posting_ratio() {
            let notPostedCounter = 0;
            this.numOfNotPostedMaterialsJournals.forEach(v => notPostedCounter+= v.count);
            let totalCounter = 0;
            this.numOfTotalMaterialsJournals.forEach(v => totalCounter+= v.count);
            return this.numOfTotalMaterialsJournals.length
                ? 100 -
                ((this.numOfNotPostedMaterialsJournals.length ? notPostedCounter : 0) * 100) /
                    totalCounter
            : 100   
        },

        material_journals_posting_ratio_tooltip() {
            let notPostedCounter = 0;
            this.numOfNotPostedMaterialsJournals.forEach(v => notPostedCounter+= v.count);
            return this.numOfNotPostedMaterialsJournals.length
                ? `${notPostedCounter} ${this.$t('unposted')}`
                : this.$t('unposted');
        },

        material_journals_posting_ratio_caption() {
            let notPostedCounter = 0;
            this.numOfNotPostedMaterialsJournals.forEach(v => notPostedCounter+= v.count);
            let totalCounter = 0;
            this.numOfTotalMaterialsJournals.forEach(v => totalCounter+= v.count);
            return `${this.numOfNotPostedMaterialsJournals.length ? notPostedCounter : 0}/${this.numOfTotalMaterialsJournals.length ? totalCounter : 0}`;
        },
        useMaterialSerialNumber() {
            return this.getSettingByKey('UseMaterialSerialNumber')?.setting_value;
        },
        serialNumberValidation() {
            return  this.tableInputs['serial-number']?.length === this.tableInputs.quantity ||  !this.getMaterialById(this.tableInputs.materialId)?.is_required_serial_num
        },
        useDublicateMaterialSerialNumberAlert() {
            return this.getSettingByKey('DuplicateSerialNumAlert')?.setting_value;
        },
    },
    methods:{
        async entryHandler() {
            await this.$nextTick();
            // to add the serial number which the user forget to save it
            if(this.useMaterialSerialNumber) {
                this.serialNumber.value
                                ? Array.isArray(this.tableInputs['serial-number']) 
                                    ? this.tableInputs['serial-number'].push(this.serialNumber) 
                                    : this.tableInputs['serial-number'] = [this.serialNumber]
                                : null
                        this.serialNumber = {}
            }
            if( this.$refs.table.validate()) {
                this.entryLoading = true;

                const actionName = !this.entryId ? 'createEntry' : 'updateEntry';

                const entryData = {
                    id: this.entryId,
                    account_id: this.tableInputs.accountId ,
                    date: this.tableInputs.date ? this.tableInputs.date : this.date,
                    count: this.tableInputs.count,
                    doc_no: this.tableInputs.docNo,
                    invoice_id: null,
                    material_id: this.tableInputs.materialId,
                    serial_number: Array.isArray(this.tableInputs['serial-number']) ? this.tableInputs['serial-number'].map(v => v.value) : [],
                    materials_journal_id: this.$route.params.id,
                    no: this.tableInputs.no ? this.tableInputs.no : 0,
                    notes: this.tableInputs.notes,
                    price: {
                            amount: this.tableInputs.amount,
                            currency_id: this.currentFinancialFile.default_currency_id
                        },
                    quantity: 
                        this.tableInputs.inQuantity 
                        ? {
                            quantity: this.tableInputs.inQuantity,
                            unit_size_id: this.materials.find(c => c.id === this.tableInputs.materialId).unit_size_id
                        }
                        : {
                            quantity: this.tableInputs.outQuantity,
                            unit_size_id: this.materials.find(c => c.id === this.tableInputs.materialId).unit_size_id
                        },
                    // type: this.tableInputs.inQuantity ? 1 : 2
                    type: this.tableInputs.inQuantity ? invoiceType.buy : invoiceType.sale
                }
                if (!entryData.id) { delete entryData.id ;}
                this.$store.dispatch(`materialsJournals/${actionName}`, {
                    journalId: this.journal.id,
                    material_entry: entryData,
                }).then(() => {
                    this.loading = true;

                    if(actionName === 'createEntry') {
                        this.$refs.table.resetInputs()
                        this.tableInputs.date = moment().format('YYYY-MM-DD');
                    } else if (actionName === 'updateEntry') {
                        this.$refs.table.resetEdit()
                        this.tableInputs.date = moment().format('YYYY-MM-DD');
                    }
                    this.tableInputs.warehouseId = this.journal?.warehouse_id || this.warehouses.find(c => c.is_default === true)?.id
                }).finally(() => {
                    this.loading = false
                    this.entryLoading = false;
                })
            }
        },
        fetchJournal(id){
            // this.$refs.table.openLoading();
            this.loading = true;
            this.entryLoading = true;
            store.dispatch("materialsJournals/fetch", { journalId: id })
            .then(response =>{
                // userTypePermission === userType.warehouseKeeper && multipleWarehouses ? materials_journals.map(c=>c.sub_journal_no).filter(c => c !== null) : materials_journals.map(c=>c.no)
                if(this.userTypePermission === this.userType.warehouseKeeper && this.multipleWarehouses) {
                    this.journalNo = response.sub_no
                } else {
                    this.journalNo = response.no;
                }
                this.changeWarehouse();
                this.materialsJournalData.date = response.date;
                this.materialsJournalData.warehouseId = response.warehouse_id || this.warehouses.find(c => c.is_default === true)?.id;
                this.materialsJournalData.notes = response.notes;
                this.materialsJournalData.type = response.type;
                this.tableInputs.warehouseId = this.journal?.warehouse_id || this.warehouses.find(c => c.is_default === true)?.id
                this.$refs.table.endLineInputValues = { date: new Date().toISOString(), warehouse_id: this.selected_warehouse_id};
                // this.$refs.table.onEsc();
                // this.$refs.table.closeLoading();
            })
            .finally(() => {
                this.loading = false
                this.entryLoading = false;
            })
        },
        updateJournal() {
            this.$store.dispatch('materialsJournals/update', {
                id: this.$route.params.id,
                notes:this.materialsJournalData.notes,
                warehouse_id: this.materialsJournalData.warehouseId,
                date: this.materialsJournalData.date,
                journal_type: this.materialsJournalData.type
            }).then(() => {
                this.fetchJournal(this.$route.params.id);
                EventBus.$emit('notification', this.$t('MaterialsJournalPage.journal-updated-successfully'));
            }).finally(() => {
            })
        },
        // fetchJournalByNo(){
        //     var materialJournal = this.materials_journals?.find(c => c.no == this.journalNo)
        //     if(materialJournal.id != Number(this.$route.params.id))
        //         this.fetchJournal(materialJournal.id)
        // },
        fetchJournalByNo(){
            var materialJournal = null
            if (this.userTypePermission === userType.warehouseKeeper && this.multipleWarehouses) {
                materialJournal = this.materials_journals?.find(c => c.sub_journal_no == this.journalNo)
                this.materials_journals.map( c => c.sub_journal_no) 
            } else {
                materialJournal = this.materials_journals?.find(c => c.no == this.journalNo)
                this.materials_journals.map(c=>c.no)
            }
            if(materialJournal.id != Number(this.$route.params.id))
                this.$router.replace({name: 'materials-journal', params: { id: materialJournal.id }, query: this.$route.query}).catch(()=>{})
        },
        deleteJournal(){
            if(this.journal.id)
                store.dispatch("materialsJournals/delete",{ journalId: this.journal.id })
                    .then(()=> 
                    {
                        store.dispatch("materialsJournals/fetchAll", { 
                            from_date: this.configs.financial_file.start_date, 
                            to_date: this.date,
                            warehouse_id: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? this.warehousesForKeeper[0].warehouse_id : null
                        })
                        .finally(()=> this.fetchLastjournal())
                        
                    })
        },
        fetchLastjournal(){
            if(this.materials_journals.length > 0)
                this.$router.replace({name: 'materials-journal', 
                    params: {id: this.materials_journals[this.materials_journals.length -1].id}, 
                    query: this.$route.query
                })
            else{
                store.dispatch("materialsJournals/clear")
                this.journalNo = null
                this.$router.replace({name: 'materials-journals'})
            }
        },
        addMaterialJournal(){
            this.loading = true

            store.dispatch("materialsJournals/create",{ date: this.date,  warehouse_id: this.warehouseId, journal_type: this.materialsJournalType })
            .then(response => { 
                this.$router.replace({name: 'materials-journal', params: { id: response.id }}).catch(()=>{})
                if (this.userTypePermission === userType.warehouseKeeper && this.multipleWarehouses) { 
                    this.journalNo = response.sub_no;
                } else {
                    this.journalNo = response.no
                }
                // this.$refs.table.onEsc();
                // this.$refs.table.resetShownRows();

                const from_date = this.configs.financial_file.start_date;
                const to_date = new Date().toISOString().substr(0, 10);
                store.dispatch("materialsJournals/fetchAll", { from_date, to_date, warehouse_id: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? this.warehousesForKeeper[0].warehouse_id : null })
            })
            .finally(() => this.reSet())
        },
        reSet(){
            this.loading = false;
            this.addEntryDialog = false
            this.date = new Date().toISOString().substr(0, 10).toString();
            this.selected_entry = null
            this.deleteEntryDialog = false
        },
        changeWarehouse(){
            EventBus.$emit('initialize-last-row', { warehouse_id: this.default_warehouse_id });
            this.tableInputs.warehouseId= this.materialsJournalData.warehouseId;
        },

        unPost(){
            if(this.journal.id)
                store.dispatch("materialsJournals/changeToNotPosted", { journalId: this.journal.id })
                .then(()=> {
                    this.fetchMaterials();
                    this.fetchJournal(this.journal.id)
                })
        },
        post(){
            if(this.journal.id)
                store.dispatch("materialsJournals/changeToPosted", { journalId: this.journal.id })
                .then(()=> {
                    this.fetchMaterials(),
                    this.fetchJournal(this.journal.id)
                })
        },
        fetchMaterials(isUpdate = true) {
            this.materialsLoading = true;
            return this.$store.dispatch('materials/fetchAll').then(() => {
                this.materialsLoading = false;
                if(isUpdate) {
                    EventBus.$emit('notification', this.$t('update-materials-notifications'))
                }
            });
        },
        // updateEntry(material_entry){ 
        //     let unit_size_id = this.materials.find(c=>c.id == this.items[material_entry.rowIndex].material_id).unit_size_id    
        //     let entry = refactorMaterialEntry(this.items[material_entry.rowIndex], this.configs.financial_file.default_currency_id, unit_size_id, { price: useZeroPriceInMaterialJournals })
            
        //     entry.materials_journal_id = this.journal.id
        //     delete entry.in_quantity
        //     delete entry.out_quantity
        //     if(this.$refs.table.$refs.table.$refs.table.valids[`valid_${material_entry.rowIndex}`])
        //         store.dispatch("materialsJournals/updateEntry", {
        //             journalId: this.journal.id,
        //             material_entry: entry,
        //         })
        //         .then(() => { 
        //             material_entry.deleteRowIndex()
        //         })
        //         .finally(()=>{
        //             material_entry.connectionEnded(1, "BeeAutocomplete")
        //         })
        //     else
        //         EventBus.$emit('error', this.$t('make-sure-the-data-entered-is-correct'))
        // },
        deleteEntry($event){
            this.selected_entry = {...$event}
            this.deleteEntryDialog = true
        },
        confirmDeleteEntry(){
            store.dispatch("materialsJournals/deleteEntry", { journalId: this.journal.id, entryId: this.selected_entry.id })
            .then(()=>{
                this.reSet()
            })
        },
        fetchEntry(entry){
            store.dispatch("materialsJournals/fetchEntry", entry.id)
        },
        forwardToMaterialStatement(entry){
            const route = this.$router.resolve({ name: 'material-statment', query: { invoiceId: this.$route.params.id,id: entry.material_id } });
            window.open(route.href, '_blank');
            
        },
        // addEntry(material_entry){
        //     let unit_size_id = this.materials.find(c=>c.id == material_entry.value.material_id).unit_size_id
        //     let entry = refactorMaterialEntry(material_entry.value, this.configs.financial_file.default_currency_id, unit_size_id, { price: useZeroPriceInMaterialJournals })
        //     const entryDate = 
        //         entry.date || (
        //             this.items.length
        //                 ? this.items[this.items.length - 1].date.slice(0, 10)
        //                 : new Date().toISOString().slice(0, 10)
        //         );

        //     entry.materials_journal_id = this.journal.id
        //     delete entry.in_quantity
        //     delete entry.out_quantity
        //     entry.date = entryDate;
        //     store.dispatch('materialsJournals/createEntry', {
        //         journalId: this.journal.id,
        //         material_entry: entry,
        //     })
        //     .then(() => {
        //         material_entry.deleteRowData({
        //             warehouse_id: this.selected_warehouse_id,
        //             date: entryDate,
        //         })
        //         this.tableInputs.warehouseId = this.journal?.warehouse_id || this.warehouses.find(c => c.is_default === true)
        //     })
        //     .finally(()=>  material_entry.connectionEnded(1, "BeeNumericField"))
        // },

        handlBlurJournalTable(entry){
            this.messagesSelectRowValidation =
                entryDetectedValidation(entry, this.linkedJournalRules, { price: useZeroPriceInMaterialJournals });
        },
        reForwardToRelatedInvoice(){
            store.dispatch("invoices/fetchInvoiceType", { invoiceId: this.journal.invoice_id}).then(response => {
                if(response == 'Buy')
                    this.$router.push({name: 'invoices-buy', params:{ id: this.journal.invoice_id }, query: {withCategory: true}})
                else if (response == 'Sale')
                    this.$router.push({name: 'invoices-sale', params:{ id: this.journal.invoice_id }, query: {withCategory: true}})
            })
        },
        reForwardToRelatedManufacturingFile(){
            this.$router.push({name: 'manufacturing-bond', query: { id: this.journal.manufacturing_file_id }})
        },

        getMaterialPrice() {
            // this.tableInputs.amount = this.materials.find(c => c.id === this.tableInputs.materialId)?.unit_size_id
            if(this.tableInputs.materialId) {
                this.$store.dispatch("materials/fetchLastPurchasePrice", this.tableInputs.materialId)
                .then(response => {
                    this.tableInputs.amount = response
                })
            }
            if(!this.tableInputs.inQuantity && this.useMaterialSerialNumber) {
                this.getMaterialSerialNumbers(this.tableInputs.materialId);
            }
        },
        checkMaterialSerialNumber(materialId, serialNumber) { 
            if(materialId && serialNumber && this.useDublicateMaterialSerialNumberAlert) {
                if(this.tableInputs['serial-number']?.find(v => v.value === serialNumber)) {
                    this.serialNumberAlertDialog = true;
                    this.serialNumberAlertText = serialNumber;
                    return
                }
                this.$store.dispatch('materials/checkSerialNumber', {materialId, serialNumber}).then(data => {
                    if(data) {
                        this.serialNumberAlertDialog = true;
                        this.serialNumberAlertText = serialNumber;
                    }
                })
            }
        },
        resetSerialNumberValue() {
            setTimeout(() => {
                this.checkMaterialSerialNumber(this.tableInputs.materialId, this.serialNumber.value)
                const serialNumber = this.serialNumber;
                if(serialNumber.value)
                {
                    Array.isArray(this.tableInputs['serial-number']) 
                        ? this.tableInputs['serial-number'].push(serialNumber) 
                        : this.tableInputs['serial-number'] = [serialNumber]
                }
                    this.serialNumber = {};
                if(!this.addSerialNumbersDialog) {
                    this.$refs['input-serial-number'].activateMenu()
                } else {
                    /*to stop opening the combobox menu*/
                    this.$refs['input-value'].isMenuActive = false
                }
            })
        },
        getMaterialSerialNumbers(materialId) {
            this.materialSerialNumbers = [];
            this.$store.dispatch('materials/getMaterialSerialNumbers', {materialId, invoiceType: invoiceType.sale}).then(data => {
                this.materialSerialNumbers = data;
                // this.materialSerialNumbers.push('111')
            })
        },
    },

    mounted(){
        window.observer.observe(document.querySelector("#tool-bar"))
        
        EventBus.$emit('initialize-last-row', { warehouse_id: this.selected_warehouse_id })
        let promises = []
        let configs = store.state.configs.configs;
        if(Object.keys(configs).length == 0)
            promises.push(store.dispatch("configs/fetchAll").then(() => {
                configs = store.state.configs.configs;
            }))

        let materials = store.state.materials.materials;
        if(materials.length === 0)
            promises.push(this.fetchMaterials(false))

        let warehouses = store.state.warehouses.warehouses;
        if(Object.keys(warehouses).length == 0)
            promises.push(store.dispatch("warehouses/fetchAll"))

        Promise.all(promises).then(async ()=>{
            // console.log(store.state.warehouses.warehousesForKeeper)
            // let financialFile = store.state.financialFiles.current_financial_file;
            let from_date = configs.financial_file.start_date;
            let to_date = new Date().toISOString().substr(0, 10);
            this.$store.dispatch("materialsJournals/fetchAll", { 
                from_date, 
                to_date,
                warehouse_id: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? this.warehousesForKeeper.length ? this.warehousesForKeeper[0].warehouse_id : null : null
            })
            .then(() => {
               if(this.$route.name === 'materials-journals' || this.$route.name === 'materials-journal') {
                    const materialsJournals = store.state.materialsJournals.materials_journals;
                    let id = null;
                    if(this.$route.params.id){
                        id = this.$route.params.id;
                        this.fetchJournal(id)
                    }
                    else{
                        id = materialsJournals[materialsJournals.length -1]?.id;
                        if(id) {
                            this.$router.replace({name: 'materials-journal', params: { id: id }, query: this.$route.query})
                        }
                        else {
                            this.loading = false;
                            this.entryLoading = false;
                        }
                    }

                    if(this.userTypePermission === userType.warehouseKeeper && this.multipleWarehouses) {
                        this.default_warehouse_id = this.warehousesForKeeper[0].warehouse_id
                        this.selected_warehouse_id = this.default_warehouse_id
                    } else {
                        this.default_warehouse_id = this.configs?.warehouse?.id
                        this.selected_warehouse_id = this.default_warehouse_id
                    }
                    this.tableInputs.date = moment().format('YYYY-MM-DD');
                    // if (id) {
                    //     store.dispatch("materialsJournals/fetch", { journalId: id })
                    //     .then(response => {
                    //         if(!to.params.id) {
                    //             if (vm.userTypePermission === userType.warehouseKeeper && vm.multipleWarehouses) { 
                    //                 vm.journalNo = response.sub_no;
                    //                 vm.$router.replace({name: 'materials-journal', params: { id }, query: to.query})
                    //             } else {
                    //                 vm.journalNo = response.no
                    //                 vm.$router.replace({name: 'materials-journal', params: { id }, query: to.query})
                    //             }
                    //         }
                    //     })
                    // }
               }
            })
        })
        EventBus.$on('warehouse-changed', (warehouse_id, material_id = null)=>{ 
            if(!warehouse_id && material_id)
            {
                // تحديث قائمة مواد المستودع
                this.selected_warehouse_id = this.materials.find(c=>c.id == material_id)?.warehouse_id
                // تعيين المستودع التابع للمادة
                EventBus.$emit('initialize-last-row', { warehouse_id: this.selected_warehouse_id })
            }    
            else
                this.selected_warehouse_id =  warehouse_id
        });
    },

    // async beforeRouteEnter(to, from, next) {
    //     let promises = []

    //     let configs = store.state.configs.configs;
    //     if(Object.keys(configs).length == 0)
    //         promises.push(store.dispatch("configs/fetchAll").then(() => {
    //             configs = store.state.configs.configs;
    //         }))

    //     let materials = store.state.materials.materials;
    //     if(materials.length === 0)
    //         promises.push(store.dispatch("materials/fetchAll"))

    //     let warehouses = store.state.warehouses.warehouses;
    //     if(Object.keys(warehouses).length == 0)
    //         promises.push(store.dispatch("warehouses/fetchAll"))

    //     await Promise.all(promises).then(async ()=>{
    //         // console.log(store.state.warehouses.warehousesForKeeper)
    //         // let financialFile = store.state.financialFiles.current_financial_file;
    //         let from_date = configs.financial_file.start_date;
    //         let to_date = new Date().toISOString().substr(0, 10);
    //         await store.dispatch("materialsJournals/fetchAll", { 
    //             from_date, 
    //             to_date,
    //             warehouse_id: store.state.permissions.user_type === userType.warehouseKeeper && multipleWarehouses ? store.state.warehouses.warehousesForKeeper.length ? store.state.warehouses.warehousesForKeeper[0].warehouse_id : null : null
    //         })
    //         .then(() => {
    //             next((vm) => {
    //                 const materialsJournals = store.state.materialsJournals.materials_journals;
    //                 let id = null;
    //                 if(to.params.id){
    //                     id = to.params.id;
    //                     vm.fetchJournal(id);
    //                 }
    //                 else{
    //                     id = materialsJournals[materialsJournals.length -1]?.id;
    //                     vm.$router.replace({name: 'materials-journal', params: { id }, query: to.query})
    //                 }
    //                 // if (id) {
    //                 //     store.dispatch("materialsJournals/fetch", { journalId: id })
    //                 //     .then(response => {
    //                 //         if(!to.params.id) {
    //                 //             if (vm.userTypePermission === userType.warehouseKeeper && vm.multipleWarehouses) { 
    //                 //                 vm.journalNo = response.sub_no;
    //                 //                 vm.$router.replace({name: 'materials-journal', params: { id }, query: to.query})
    //                 //             } else {
    //                 //                 vm.journalNo = response.no
    //                 //                 vm.$router.replace({name: 'materials-journal', params: { id }, query: to.query})
    //                 //             }
    //                 //         }
    //                 //     })
    //                 // }
    //             });
    //         })
    //     })
    // }
}
</script>

<style scoped>
.border {
	border: 1px solid #f1f1f1;
    border-radius: 8px;
}
</style>